// Presentation promoted to the shared common/ui pill so flights and hotels share one
// source of truth. Kept as a thin re-export for the colocated logic layer.
export { LobTabs, default } from '@/src/components/common/ui/lobTabs'
export type { LobTabItem, LobTabsProps } from '@/src/components/common/ui/lobTabs'
